import _createForOfIteratorHelper from "D:/svnworkspace/GZEB/webWorks/e-boat-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { tree } from '@/api/system/department';
import { DEPARTMENT_STATUS } from '@/constant/system/code';

import { ref, computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'DepartmentSelect',
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    modelValue: {},
    valueKey: {
      default: 'departmentCode'
    },
    deptDisabled: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disableChildren: {
      type: Boolean,
      default: true
    },
    flat: {
      type: Boolean,
      default: false
    },
    lazyLoad: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showLoading: {
      type: Boolean,
      default: true
    },
    collapseTags: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var prop = __props;
    var emit = __emit;
    var selectLoading = ref(false);
    var options = ref([]);
    var selectValue = computed({
      get: function get() {
        return prop.modelValue;
      },
      set: function set(val) {
        emit('update:modelValue', val);
      }
    });
    init();
    function init() {
      if (prop.multiple) {
        selectValue.value = prop.modelValue ? prop.modelValue : [];
      } else {
        selectValue.value = prop.modelValue ? prop.modelValue : null;
      }
      loadTree();
    }
    function handleSelectVisibleChange(visible) {
      if (visible && prop.lazyLoad && options.value.length === 0) {
        refresh();
      }
    }
    function refresh() {
      loadTree();
    }
    function loadTree() {
      if (selectLoading.value) {
        return;
      }
      selectLoading.value = true;
      tree({}).then(function (result) {
        var treeData = result.data;
        var opt = [];
        if (treeData && treeData.length > 0) {
          var _iterator = _createForOfIteratorHelper(treeData),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var dept = _step.value;
              opt.push(buildOption(dept));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        options.value = opt;
      }).finally(function () {
        selectLoading.value = false;
      });
    }
    function buildOption(dept, parentOption) {
      var option = dept2Option(dept);
      if (parentOption && parentOption.disabled && prop.disableChildren) {
        option.disabled = true;
      }
      option.children = [];
      if (dept.children && dept.children.length > 0) {
        var _iterator2 = _createForOfIteratorHelper(dept.children),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var child = _step2.value;
            option.children.push(buildOption(child, option));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      return option;
    }
    function dept2Option(dept) {
      var disabled = prop.deptDisabled(dept) || dept.status === DEPARTMENT_STATUS.DISABLED.CODE;
      return {
        value: extractValue(dept),
        label: "".concat(dept.departmentName, " - ").concat(dept.departmentCode),
        disabled: disabled
      };
    }
    function extractValue(dept) {
      return dept[prop.valueKey];
    }
    return function (_ctx, _cache) {
      var _component_x_tree_select = _resolveComponent("x-tree-select");
      return _openBlock(), _createBlock(_component_x_tree_select, {
        modelValue: _unref(selectValue),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(selectValue) ? selectValue.value = $event : null;
        }),
        loading: _unref(selectLoading) && _ctx.showLoading,
        flat: _ctx.flat,
        multiple: _ctx.multiple,
        options: _unref(options),
        "collapse-tags": _ctx.collapseTags,
        placeholder: "选择部门",
        "no-options-text": "暂无选项",
        "auto-expand-checked-node": true,
        "include-half-checked-node": false,
        clearable: true,
        onVisibleChange: handleSelectVisibleChange
      }, null, 8, ["modelValue", "loading", "flat", "multiple", "options", "collapse-tags"]);
    };
  }
});